module.exports = __webpack_public_path__ + "img/celt-Unselected.c043009e.webp";